import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export const TransferDialog = ({ state, onClose, currentPoolId, onDone }) => {
  const [pools, setPools] = useState([]);
  const [target, setTarget] = useState("");
  const open = Boolean(state);

  useEffect(() => {
    if (!open) return;
    setTarget("");
    api.get("/pools").then((r) => setPools(r.data.filter((p) => p.id !== currentPoolId)));
  }, [open, currentPoolId]);

  const submit = async () => {
    try {
      await api.post(`/questions/${state.question.id}/transfer`, { target_pool_id: target, mode: state.mode });
      toast.success(state.mode === "move" ? "Soru taşındı" : "Soru kopyalandı");
      onDone();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[rgba(15,23,42,0.55)] border-[rgba(71,85,105,0.45)]" data-testid="transfer-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{state?.mode === "move" ? "Başka havuza taşı" : "Başka havuza kopyala"}</DialogTitle>
        </DialogHeader>
        <p className="text-slate-300 line-clamp-2">{state?.question.text}</p>
        {pools.length === 0 ? (
          <p className="text-slate-400 text-sm" data-testid="transfer-no-pools">Başka havuz yok. Önce yeni bir havuz oluşturun.</p>
        ) : (
          <Select value={target} onValueChange={setTarget}>
            <SelectTrigger className="h-12" data-testid="transfer-target-select"><SelectValue placeholder="Hedef havuzu seçin" /></SelectTrigger>
            <SelectContent>{pools.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
          </Select>
        )}
        <DialogFooter>
          <Button onClick={submit} disabled={!target} className="font-bold" data-testid="transfer-submit-button">
            {state?.mode === "move" ? "Taşı" : "Kopyala"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
